const React = require('react');
const PropTypes = require('prop-types');
const { formatText } = require('core/i18n').i18n;
const { formatAmount } = require('utilities/currencyHelper');
const holdingIndustryType = require('utilities/holdingIndustryType');
import FlexibleTable, { Column, Header } from 'components/charts/FlexibleTable/FlexibleTable';


const PortfolioHoldingsMobile = ({ data }) => (
    <FlexibleTable data={data}>
        <Header dataKey="securityName" />
        <Column dataKey="industryId" format={v => holdingIndustryType(v)} header={formatText('fundsCard-field')} />
        <Column dataKey="countryId" header={formatText('fundsCard-country')} />
        <Column dataKey="weighting" header={formatText('fundsCard-percentage')} format={v => `${formatAmount(v)}%`} />
    </FlexibleTable>
);


PortfolioHoldingsMobile.propTypes = {
    data: PropTypes.array.isRequired,
};


module.exports = PortfolioHoldingsMobile;
